<!--
 * @Author: 仙道
 * @Date: 2022-08-13 19:03:22
 * @LastEditTime: 2022-08-14 12:43:02
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/DevMaintainceTaskListForPerson.vue
-->
<template>
  <a-card :bordered="false">
    <!-- table区域-begin -->
    <div v-if="pageTypeEumList">
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="status" slot-scope="text">
          <a-tag :color="filterStatus(text,1)">{{filterStatus(text,2)}}</a-tag>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />-->
          <a @click="handleRecord(record)">{{record.taskStatus==2?'查看':'记录'}}</a>
          <!-- <a-divider type="vertical" /> -->

          <!-- <a @click="handleDetail(record)">详情</a> -->

          <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>
      </a-table>
    </div>
    <maintaince-plan-calendar v-else />

    <dev-maintaince-task-modal @ok="modalFormOk" ref="modalForm"></dev-maintaince-task-modal>
    <task-device-modal :canEdit="canEdit" @ok="modalFormOk" ref="taskDevice"></task-device-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevMaintainceTaskModal from './modules/DevMaintainceTaskModal'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import TaskDeviceModal from './modules/TaskDeviceModal'
  import MaintaincePlanCalendar from './MaintaincePlanCalendar.vue'

  export default {
    name: 'DevMaintainceTaskList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevMaintainceTaskModal, TaskDeviceModal,
      MaintaincePlanCalendar
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }
    },
    //finishName
    data () {
      return {
        description: '保养任务/记录管理页面',
        // 表头
        columns: [
          {
            title: '任务单号',
            align: "center",
            dataIndex: 'taskCode',
            width: 167,
          },
          {
            title: '保养计划名称',
            align: "center",
            dataIndex: 'planName',
            width: 167,
          },

          {
            title: '计划执行时间',
            align: "center",
            dataIndex: 'planTime',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '实际执行时间',
            align: "center",
            dataIndex: 'realTime',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '任务状态',
            align: "center",
            dataIndex: 'taskStatus',
            //status
            scopedSlots: { customRender: 'status' }

            // customRender: function (text) {
            //   return  filterDictTextByCache('dev_maintaince_task_status', text)
            // }
          },
          //responsibleId_dictText
          {
            title: '责任人',
            align: "center",
            dataIndex: 'responsibleId_dictText',
            //status
          },
          {
            title: '任务完成人',
            align: "center",
            dataIndex: 'finishName',
            width: 167,
          },
          //planName

          {
            title: '养护过程',
            align: "center",
            dataIndex: 'content'
          },
          {
            title: '附件',
            align: "center",
            dataIndex: 'pictures'
          },


          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 187,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/maintenance/devMaintainceTask/list",
          delete: "/maintenance/devMaintainceTask/delete",
          deleteBatch: "/maintenance/devMaintainceTask/deleteBatch",
          exportXlsUrl: "/maintenance/devMaintainceTask/exportXls",
          importExcelUrl: "maintenance/devMaintainceTask/importExcel",
        },
        pageType: 'list',

        dictOptions: {},
        superFieldList: [],
        canEdit: true,
        queryParam: {},
        disableMixinCreated: true,
      }
    },
    created () {
      this.getSuperFieldList();
      this.queryParam = { ...this.query }
      this.loadData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      pageTypeEumList () {
        return this.pageType === 'list'
      }
    },
    methods: {
      triggerBtn (val) {
        this.pageType = val
      },
      initDictConfig () {
      },
      filterStatus (text, type) {
        const color = {
          // '#52c41a':'#ff4d4f'
          '0': '#87d068',
          '1': '#2db7f5',
          '2': '#108ee9'
        }

        return type == 1 ? color[text] : this.$filterDictTextByCache('dev_maintaince_task_status', text)
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'int', value: 'planId', text: '保养计划标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'taskCode', text: '任务单号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'finishId', text: '任务完成人标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'finishName', text: '任务完成人名称', dictCode: '' })
        fieldList.push({ type: 'date', value: 'planTime', text: '计划执行时间' })
        fieldList.push({ type: 'date', value: 'realTime', text: '实际执行时间' })
        fieldList.push({ type: 'string', value: 'content', text: '养护过程', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pictures', text: '附件', dictCode: '' })
        fieldList.push({ type: 'int', value: 'taskStatus', text: '任务状态(0待进行,1进行中,2已完成)', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tenantId', text: '租户标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司标识', dictCode: '' })
        this.superFieldList = fieldList
      },
      handleRecord (record) {
        this.$refs.taskDevice.edit(record)
        this.$refs.taskDevice.title = record.taskStatus !== 2 ? '保养记录回填清单' : '保养清单'
        this.canEdit = record.taskStatus !== 2
        this.$refs.taskDevice.disableSubmit = record.taskStatus == 2
      },
      handleAdd () {
        this.$refs.taskDevice.add()
        this.$refs.taskDevice.title = '保养记录新增'
        this.$refs.taskDevice.disableSubmit = false
      }
      // handleDetail: function (record) {
      //   this.$refs.taskDevice.edit(record)
      //   this.$refs.taskDevice.title = '详情'
      //   this.$refs.taskDevice.disableSubmit = true
      // },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>